<template>
  <el-tree-select
    v-model="org_id"
    :data="orgLists"
    check-strictly
    style="width: 100%"
    filterable
    clearable
    @clear="clear"
    :props="treeSelectProps"
    value-key="id"
    accordion
    @node-click="handleNodeClick"
  />
</template>

<script setup>
import { getTreeList } from '@/api/personnel-management/index'
import { onMounted, ref, watch } from 'vue'

const emit = defineEmits(['change', 'update:modelValue'])
const { modelValue } = defineProps(['modelValue'])

const org_id = ref(modelValue)
const orgLists = ref([])
const treeSelectProps = { label: 'name', children: 'org_list' }

watch(() => modelValue, (val) => org_id.value = val)

onMounted(() => {
  getData()
})

async function getData(name) {
  const params = {}
  if (name) {
    params.name = name
  }
  const { result } = await getTreeList(params)
  if (result) {
    orgLists.value = [result.data]
  }
}

function handleNodeClick(e) {
  emit('update:modelValue', e.id)
  emit('change')
}

function clear() {
  emit('update:modelValue', undefined)
  emit('change')
}
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
}
</style>
